import React from 'react';
import { StepHeader } from '../ui/StepHeader.jsx';
import { StepIntro } from '../ui/StepIntro.jsx';
import { Icon } from '../ui/Icon.jsx';
import { centsToReais } from '../utils/masks.js';
import { getVocabulary } from '../utils/vocabulary.js';

/**
 * Upsell step — shown after AmountStep when:
 *   - OneTime frequency was selected
 *   - Monthly frequency exists
 *   - Upsell.Enabled is true
 *
 * Proposes converting the one-time donation to monthly at Upsell.Percentage of the amount.
 */
export function UpsellStep({ config, formData, onAccept, onDecline, onBack, onClose, isInline }) {
   const { Upsell, Frequencies } = config.Behaviour;
   const vocab = getVocabulary(config);

   const percentage = Upsell?.Percentage || 60;
   const oneTimeAmount = formData.amount || 0;
   const suggestedMonthly = Math.round(oneTimeAmount * percentage / 100);

   const monthlyFreq = Frequencies.find(f => f.Id === 'Monthly');

  // Ensure suggested monthly meets the minimum
  const minMonthly = monthlyFreq?.MinAmount || 0;
  const finalMonthlyAmount = Math.max(suggestedMonthly, minMonthly);

  function formatAmount(value) {
    return <span className="tdw-money">R${centsToReais(value)}</span>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <StepHeader onClose={onClose} showClose={!isInline} />

      <div className="tdw-upsell-body">
        <StepIntro title="Torne-se um apoiador mensal" />

        <p className="tdw-upsell-text">
          Deseja converter sua contribuição de{' '}
          <strong>{formatAmount(oneTimeAmount)}</strong> em {vocab.an} {vocab.term} mensal?
          Seu apoio contínuo nos ajuda a focar melhor em nosso trabalho.
        </p>

        <button
          type="button"
          className="tdw-btn-cta"
          onClick={() => onAccept(finalMonthlyAmount)}
        >
          <span className="tdw-btn-cta-heart"><Icon name="heart" size={16} /></span>
          {vocab.verbCapitalized} {formatAmount(finalMonthlyAmount)}/mês
        </button>

        <button
          type="button"
          className="tdw-btn-link"
          onClick={onDecline}
        >
          Não, manter {vocab.my} {vocab.term} {vocab.oneTimeAdjective} de {formatAmount(oneTimeAmount)}
        </button>

        <button
          type="button"
          className="tdw-btn-link"
          onClick={onBack}
        >
          ← Voltar
        </button>
      </div>
    </div>
  );
}
